import { ZodSchema } from "zod";

export const requiredFieldMessage = "این فیلد نباید خالی باشد";

export type GeneralObject<T> = {
  [key: string]: T;
};

export type HeaderOption = {
  state: string;
  image: string;
  selectedImage: string;
  intactUrl?: boolean
};

export type ServerResponse = {
  data: any;
};

export type PageType = {
  isDesktop?: boolean;
  modalBased?: boolean;
  disableBanner?: boolean;
  forceOpenStudentsList?: () => void;
  specialPostAction?: (fullClosure?: boolean) => void;
};

export type Interval = {
  start: Date;
  end: Date;
};

export type ApiCallType = {
    url: string | null | undefined; 
    key: string | null | undefined; 
    fallbackData: unknown | null | undefined; 
    requestId?: string | null | undefined;
    schemaValidator: ZodSchema | null | undefined;
    deep?: boolean | null;
    invalidateCache?: boolean | null;
    skipValidationType?: boolean;
    refreshSingal?: number;
    avoidCancelPreviosRequest?: boolean;
    headers?: GeneralObject<string>;
    customDataKey?: string;
    onError?: () => void;
}